import React, { useState, useEffect } from 'react';
import { Col, Row,Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { TimerAlert } from '../../utils/swtAlert';
import { ForgotPasswordLink } from '../../utils/axios/Auth';
import { GrokLoading } from '../page-layout/loading/Loading';
function Forgetpassword(props) {
    const navigate = useNavigate();

    //Form Control Variables Starts..
    const [email, setEmail] = useState();
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    //Form Control Variables Ends..

    const BackBtn = () => {
        navigate('/login');
    }
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            handleForgotPasswordLink();
        }
    };

    const handleForgotPasswordLink = async () => {
        let forgotPasswordLinkPayload = {
            Email: email
        }
        setLoading(true);
        let forgotPasswordLinkResponse = await ForgotPasswordLink(forgotPasswordLinkPayload);
        setLoading(false);
        if (forgotPasswordLinkResponse.success){
            var delay = TimerAlert('success', 'Reset Password Link set to your email', 'success');
            setTimeout(() => navigate("/login"), delay);
        }
    }

    useEffect(() => {
        //sendEmailResetpassword();
    }, [])

    return (
        <div className="rootmain border-top-wide border-primary d-flex flex-column theme-light">
            <div className='page page-center'>
                {loading ? <GrokLoading /> : ""}
                <div className='text-center mb-3'>
                    {/* <a href="#" className='navbar-brand navbar-brand-autodark'>
                        <img src={require('../../images/grok pvt ltd logo.png')} className='img-fluid' width={200} />
                    </a> */}
                    <h1 className="navbar-brand navbar-brand-autodark">
                        <div className='light-logo'>
                            <Link to='/home'>
                                <img src={require('../../images/grok pvt ltd logo.png')} width="50" height="32" alt="Logo" className="img-fluid navbar-brand-image" />
                            </Link>
                        </div>
                        <div className='dark-logo'>
                            <Link to='/home'>
                                <img src={require('../../images/grok pvt ltd logo_dark.png')} width="50" height="32" alt="Logo" className="img-fluid navbar-brand-image" />
                            </Link>
                        </div>
                    </h1>
                </div>
                <div className='container-tight py-2'>
                    <Form noValidate className='card card-md' validated={validated} onSubmit={handleSubmit}>
                        <div className='card-body'>
                            <h3 className='card-title text-center mb-4'>Forgot password</h3>
                            <p className='text-muted mb-4'>Please enter your email address below to receive a link.</p>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter your email" onChange={(e) => setEmail(e.target.value)} required />
                            </Form.Group>
                            <Row>
                                <Col>
                                    <Button  variant="secondary" type="submit" size="sm" onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp; Back</Button>
                                </Col>
                                <Col className='col-md-auto'>
                                    <Button  variant="primary" size="sm" type="submit"> Reset password </Button>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </div>

            </div>
        </div>
    );
}

export default Forgetpassword;
